<template>
    <div class="exhibitionDetails">
        <!-- 加载状态 -->
        <el-loading v-loading="loading" element-loading-text="正在加载中..." element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <!-- 错误提示 -->
            <div v-if="errorMsg" class="error-message">
                <el-alert :title="errorMsg" type="error" show-icon :closable="false" />
            </div>

            <div class="exhibitionCenterDetails_breadcrumb wd1600">
                <el-breadcrumb :separator-icon="ArrowRight">
                    <el-breadcrumb-item>便捷服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/trainServices' }">培训服务</el-breadcrumb-item>
                    <el-breadcrumb-item class="zhmc">{{ exhibitionDetailsData.kcmc }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="exhibitionCenterDetails_content wd1600" id="exhibitionCenterDetails_content">
                <div class= 'comConbox'>
                    <div class="conboxleft">

                        <div v-if = "exhibitionDetailsData.kcljfs == '内链' " class = 'vadioBox'>
                            <video ref="videoPlayer" muted class= 'vadioBox' id="myvideo" 
                                :poster="commenUrl + exhibitionDetailsData.kctp"
                                @play="onVideoPlay"
                                @pause="onVideoPause"
                                @ended="onVideoEnded">
                                <source :src = 'exhibitionDetailsData.kcsplj' type="video/mp4">
                                您的浏览器不支持视频播放
                            </video>
                            <!-- 修改：添加播放按钮控制 -->
                            <img v-show = 'showPlayButton' @click = 'handlePlayVideo' class = 'bfImg' 
                                src="../../assets/images/bfImg.jpg" alt="播放按钮">
                        </div>

                       
                        <div v-else class = 'vadioBox'> 
                            <img @click = 'handleclickwladd(exhibitionDetailsData.kcsplj)'  class= 'vadioBox' :src="commenUrl + exhibitionDetailsData.kctp" alt="">
                            <img class = 'bfImg' src="../../assets/images/bfImg.jpg" @click = 'handleclickwladd(exhibitionDetailsData.kcsplj)' alt="">
                        </div>

                        <!-- <img @click = 'handleclickwladd(exhibitionDetailsData.kcsplj)' v-else class= 'vadioBox' :src="commenUrl + exhibitionDetailsData.kctp" alt=""> -->
                    </div>
                    <div class="conboxlright">
                        <div class = 'rightItem' v-for = '(item,index) in XgList' :key = 'index' @click = 'handleclicktlList(item._id)' >
                            <div :class = "flagId == item._id? 'IsitemWrite': 'itemWrite' ">{{ item.kcmc }}</div>
                        </div>
                    </div>
                </div>
                <div class="exhibitionCenterDetails_content_head">
                    <div class="exhibitionCenterDetails_content_head_left">

                        <div class="exhibitionCenterDetails_content_head_left_desc">
                            <el-tooltip class="box-item" effect="dark" :content="exhibitionDetailsData.kcmc">
                                <div class="exhibitionCenterDetails_content_head_left_desc_title">
                                    {{ exhibitionDetailsData.kcmc }}
                                </div>
                            </el-tooltip>

                        </div>

                    </div>
                    <div style="margin-top: 13px;display: flex; flex-wrap: wrap;align-items: baseline;">
                        <div style="width: 75px;font-size: 14px;color: #BEBEBE;"> 课程简介：</div>
                        <div style="flex: 1;font-size: 14px;color: #595959;line-height: 26px;">
                            {{ exhibitionDetailsData.kcjj }}</div>
                    </div>
                </div>
            </div>
            <div class="exhibitionCenterDetails_content_tab wd1600">
                <div class="exhibitionCenterDetails_content_tab_item">
                    <span :class="{ 'active': item.label === activeTab }" v-for="item in tabList" :key="item.label"
                       >{{ item.label }}</span>
                </div>
                <div class="exhibitionCenterDetails_content_tab_box">
                    <div class="exhibitionCenterDetails_content_tab_box_line" >
                        <div v-html="exhibitionDetailsData.kcxq || '暂无课程信息'" class="expo-detail-content"></div>
                    </div>
                    <!-- <div class="exhibitionCenterDetails_content_tab_box_line" v-show="activeTab === '培训总结'">
                        <div v-html="exhibitionDetailsData.pxhg || '暂无培训总结'" class="expo-layout-content"></div>
                    </div> -->
                </div>
            </div>
        </el-loading>
    </div>


</template>
<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ArrowRight } from '@element-plus/icons-vue'

const { proxy } = getCurrentInstance();
const route = useRoute()
const router = useRouter()
// 获取路由信息
const id = ref(route.query.id)
const type = ref(route.query.type)
const zhType = ref('1')
// tab数据
const tabList = ref([
    {
        label: '课程信息'
    },

])


// 定义展会详情数据变量
const exhibitionDetailsData = ref({})
const loading = ref(false)
const errorMsg = ref('')

const handleclicktlList = (value) =>{
    flagId.value = value
    id.value = value
    exhibitionDetails()
    getXgList()
}

const flagId = ref('')
//展会详情
const exhibitionDetails = () => {

    errorMsg.value = ''

    proxy.$request({
        url: "PXFW_COURSESDETAIL",
        method: "post",
        data: {
            id: id.value
        }
    }).then((res) => {

        if (res.data.code == "000") {
            exhibitionDetailsData.value = res.data.result || {};
            flagId.value = res.data.result._id
            getXgList(res.data.result.kclb)
        } else {
            errorMsg.value = res.data.message || '获取课程详情失败'
        }
    }).catch((err) => {

        errorMsg.value = '网络请求失败，请稍后重试'
        console.error('获取展会详情失败:', err);
    });
}

const XgList = ref([])

const handleclickwladd = (url) =>{
    window.open(url)
}

const videoflag = ref(true)

// 视频播放器引用
const videoPlayer = ref(null)
// 控制播放按钮显示
const showPlayButton = ref(true)


// 视频播放相关方法
const handlePlayVideo = () => {
    if (videoPlayer.value) {
        // 显示播放控件
        videoPlayer.value.controls = true
        // 播放视频
        videoPlayer.value.play().then(() => {
            showPlayButton.value = false
        }).catch(error => {
            console.error('播放失败:', error)
            // 如果自动播放失败，显示控件让用户手动播放
            videoPlayer.value.controls = true
        })
    }
}

// 视频开始播放时
const onVideoPlay = () => {
    showPlayButton.value = false
}

// 视频暂停时
const onVideoPause = () => {
    showPlayButton.value = true
}

// 视频播放结束时
const onVideoEnded = () => {
    showPlayButton.value = true
    // 可选：重置视频到开始位置
    if (videoPlayer.value) {
        videoPlayer.value.currentTime = 0
        videoPlayer.value.controls = false
    }
}



const getXgList = (id) => {
    errorMsg.value = ''
    proxy.$request({
        url: "PXFW_COURSESSAMELIST",
        method: "post",
        data: {
            'kclb': id,
            // 'count':4
        }
    }).then((res) => {
        if (res.data.code == "000") {
            XgList.value = res.data.result || [];
            if( XgList.value.length>11){
                XgList.value =  XgList.value.slice(0,11)
            }
        } else {
            errorMsg.value = res.data.message || '获取课程详情失败'
        }
    }).catch((err) => {
        errorMsg.value = '网络请求失败，请稍后重试'
        console.error('获取展会详情失败:', err);
    });
}











onMounted(() => {
    // 如果有ID参数，则获取展会详情
    if (id.value) {
        exhibitionDetails()
    }




})
</script>
<style lang="less" scoped>
.exhibitionDetails {
    height: 100%;
    background: #f7f7f7;
    padding-top: 20px;

    .error-message {
        width: 1600px;
        margin: 20px auto;
        padding: 0 20px;
    }

    .expo-detail-content,
    .expo-layout-content {
        padding: 20px; // 内容距离两边10%
        min-height: 400px;
        text-align: left; // 文字居左对齐
    }

    .expo-detail-content :deep(p),
    .expo-layout-content :deep(p) {
        margin-bottom: 16px;
        line-height: 1.8;
        text-align: left; // 确保段落文字居左
        max-width: 100%; // 确保段落不超出容器
    }

    // 图片样式 - 撑满容器
    .expo-detail-content :deep(img),
    .expo-layout-content :deep(img) {
        max-width: 100% !important; // 富文本宽度100%
        width: 100% !important; // 强制撑满容器宽度
        height: auto !important;
        display: block !important;
        cursor: pointer;
        margin: 0 auto !important; // 图片居中显示
        object-fit: contain !important; // 保持图片比例
        box-sizing: border-box !important; // 确保内边距和边框不影响宽度
    }

    // 视频样式
    .expo-detail-content :deep(video),
    .expo-layout-content :deep(video) {
        max-width: 100%; // 富文本宽度100%
        height: auto;
        display: block;
        overflow: hidden; // 防止溢出
        margin: 0 auto; // 视频居中显示
    }

    // 不对视频链接图片进行特殊处理

    // 视频容器样式
    .video-wrapper {
        position: relative;
        width: 100%;
        max-width: 800px;
        margin: 16px 0;
    }

    // 视频播放器样式
    .video-player {
        width: 100%;
        height: auto;
        display: block;
    }

    .wd1600 {
        // max-width: 1680px;
        // min-width: 1200px;
        // width: 100%;
        width:1200px;
        margin: 0 auto;
    }

    // 响应式设计 - 屏幕宽度小于1680px
    @media  (min-width: 1680px) {
        .wd1600 {
            width: 1600px;
            padding: 0 20px;
        }

        .exhibitionCenterDetails_content {
            padding: 20px;
            border-radius: 20px 20px 0 0 ;
        }

        .exhibitionCenterDetails_content_head_left {
            // max-width: calc(100% - 320px) !important;
        }

        .exhibitionCenterDetails_content_head_left img {
            width: 240px;
            height: 148px;
        }

        .exhibitionCenterDetails_content_head_imgbox {
            width: 300px !important;
        }
    }

    // 响应式设计 - 屏幕宽度小于1400px
    @media screen and (max-width: 1400px) {
        .exhibitionCenterDetails_content_head_left {
            // max-width: calc(100% - 280px) !important;
        }

        .exhibitionCenterDetails_content_head_left img {
            width: 200px;
            height: 124px;
        }

        .exhibitionCenterDetails_content_head_imgbox {
            width: 260px !important;
        }

        .exhibitionCenterDetails_content_head_imgbox_img img {
            width: 80px !important;
            height: 80px !important;
        }
    }

    // 响应式设计 - 屏幕宽度小于1200px
    @media screen and (max-width: 1200px) {
        .wd1600 {
            min-width: 1200px;
            overflow-x: auto;
        }

        .exhibitionCenterDetails_content {
            
            // flex-direction: column;
            // height: auto !important;
            // gap: 30px;
        }

        .exhibitionCenterDetails_content_head_left {
            max-width: 100% !important;
            width: 100%;
        }

        .exhibitionCenterDetails_content_head_right {
            width: 100%;
            justify-content: center;
        }

        .exhibitionCenterDetails_content_head_imgbox {
            width: 100% !important;
            justify-content: space-around;
        }
    }

    .exhibitionCenterDetails_breadcrumb {
        height: 50px;
        background: #FFFFFF;
        padding: 15px;
        color: #333333;

        .el-breadcrumb {
            line-height: 20px;
        }

        .zhmc {
            max-width: 40%;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .exhibitionCenterDetails_content {
        background: #FFFFFF;
        padding: 30px;
        margin-top: 20px;
        border-radius: 20px 20px 0 0 ;
        .comConbox{
            width:100%;
            height:667px;
            display: flex;
            margin-bottom:20px;
            .conboxleft{
                width:75%;
                height:100%;
                background:#f7f7f7;
                margin-right:30px;
                .vadioBox{
                    width:100%;
                    height:100%;
                    position: relative;
                    video {
                    width: 100%;
                    height: 100%;
                    object-fit: cover; /* 保持视频比例 */
                    cursor: pointer;
                }
                
                .bfImg {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: 100px;
                    height: 100px;
                    cursor: pointer;
                    z-index: 10;
                    transition: opacity 0.3s ease;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                }
                    
                }
            }
            .conboxlright{
                width:23%;
                height:100%;
                background:#fff;
                padding-right:30px;
                
                .rightItem{
                    width:100%;
                    height:60px;
                    border-bottom:1px solid #DDDBDB;
                    display: flex;
                    justify-content: space-around;
                    flex-direction: column;
                    cursor: pointer;
                    .itemWrite{
                        height: 20px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: 14px;
                        color: #121212;
                        line-height: 20px;
                        text-align: left;
                        font-style: normal;
                        padding-left:20px;
                        border-left:5px solid #fff;
                        width:100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .IsitemWrite{
                        height: 20px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: 14px;
                        color: #1663FF;
                        line-height: 20px;
                        text-align: left;
                        font-style: normal;
                        padding-left:20px;
                        border-left:5px solid #1663FF;
                        width:100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    } 
                }
               
            }
        }

        .exhibitionCenterDetails_content_head {

            // height: 174px;
            // display: flex;
            // justify-content: space-between;
            // align-items: center;
            .exhibitionCenterDetails_content_head_left {
                height: 100%;
                display: flex;
                align-items: center;
                flex: 1;
                justify-content: space-between;

                // max-width: calc(100% - 380px);
                img {
                    width: 280px;
                    height: 174px;
                    margin-right: 20px;
                    border-radius: 10px;
                    flex-shrink: 0;
                }

                .exhibitionCenterDetails_content_head_left_desc {
                    height: 100%;
                    // flex: 1;
                    // display: flex;
                    // flex-direction: column;
                    // justify-content: space-between;
                    min-width: 0;

                    .exhibitionCenterDetails_content_head_left_desc_title {
                        font-family: AlibabaPuHuiTi_2_105_Heavy;
                        font-size: 20px;
                        font-weight: 500;
                        color: #191919;
                        line-height: 32px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .exhibitionCenterDetails_content_head_left_desc_subtitle {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #595959;
                        line-height: 22px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        word-break: break-word;
                    }

                    .exhibitionCenterDetails_content_head_left_desc_time_place {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #595959;
                        line-height: 20px;

                        .exhibitionCenterDetails_content_head_left_desc_place {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }

                    .exhibitionCenterDetails_content_head_left_desc_btn {
                        display: inline-block;
                        width: 160px;
                        height: 33px;
                        line-height: 33px;
                        text-align: center;
                        background: linear-gradient(180deg, #FEF3F2 0%, #FCE3E0 100%);
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #F23030;
                        white-space: nowrap;
                        border-radius: 17px;
                        margin: 0;

                        span {
                            font-size: 14px;
                            font-weight: 500;
                            padding: 0 2px;
                            line-height: 18px;
                        }
                    }

                    .exhibitionCenterDetails_content_head_left_desc_btn_status1 {
                        background: linear-gradient(180deg, #E6F7EF 0%, #C3F1DD 100%);
                        color: #36A47F;
                    }

                    .exhibitionCenterDetails_content_head_left_desc_btn_status2 {
                        background: linear-gradient(180deg, #F5F5F5 0%, #EAEAEA 100%);
                        color: #8C8C8C;
                    }
                }
            }

            .exhibitionCenterDetails_content_head_right {
                flex-shrink: 0;

                .exhibitionCenterDetails_content_head_imgbox {
                    width: 360px;
                    height: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .exhibitionCenterDetails_content_head_imgbox_img {
                        height: 140px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;

                        img {
                            width: 92px;
                            height: 92px;
                            border-radius: 50%;
                            cursor: pointer;
                        }

                        div {
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #595959;
                            line-height: 20px;
                        }

                        .p1 {
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #717271;
                            line-height: 17px;
                        }

                        .p2 {
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #595959;
                            line-height: 17px;
                        }
                    }

                    .exhibitionCenterDetails_content_head_imgbox_img:not(:last-child) {
                        position: relative;
                    }

                    .exhibitionCenterDetails_content_head_imgbox_img:not(:last-child)::after {
                        content: '';
                        position: absolute;
                        top: 24px;
                        right: -20px;
                        width: 1px;
                        height: 92px;
                        background: #EDEDED;
                    }
                }
            }
        }
    }

    .exhibitionCenterDetails_content_tab {
        padding: 20px;
        background: #FFFFFF;
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px;

        .exhibitionCenterDetails_content_tab_item {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #D8D8D8;
            padding: 10px 0;

            span {
                margin-right: 40px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: #191919;
                cursor: pointer;
                transition: all 0.3s ease;
                position: relative;
                padding-bottom: 8px;

                &:hover,
                &.active {
                    font-size: 20px;
                    color: #191919;

                    &::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        top: 37px;
                        left: 0;
                        width: 100%;
                        height: 4px;
                        background: #191919;
                    }
                }
            }
        }

        .exhibitionCenterDetails_content_tab_box {
            padding: 30px 0 0;
            background: #fff;

            .exhibitionCenterDetails_content_tab_box_line {

                // 为分页组件所在的容器添加居中样式
                .el-pagination {
                    display: flex;
                    justify-content: center;
                    margin: 20px 0;
                }

                .list {
                    .list_item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-family: PingFangSC, PingFang SC;
                        font-size: 16px;
                        color: #191919;
                        line-height: 22px;
                        width: 100%;
                        background: #F5F5F5;
                        border-radius: 10px;
                        padding: 18px 30px;
                        margin-bottom: 20px;
                        cursor: pointer;

                        .list_item_left {
                            white-space: nowrap;
                            overflow: hidden;
                            font-weight: 600;
                            text-overflow: ellipsis;
                            flex-grow: 1;
                            max-width: 100%;
                        }

                        .list_item_right {
                            font-size: 12px;
                            color: #595959;
                            display: flex;
                            align-items: center;
                            flex-shrink: 0;
                            margin-left: 10px;
                            cursor: pointer;

                            span {
                                margin-right: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
}

/* 在线视频容器样式 */
.online-video-wrapper {
    width: 100%;
    margin: 16px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
    padding: 10px;
    border-radius: 8px;
}

/* 在线视频播放器样式 */
.online-video-container {
    max-width: 100%;
    max-height: 500px;
    width: 100%;
    height: auto;
    border-radius: 4px;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .online-video-container {
        max-height: 300px;
    }
}

    @media (max-width: 768px) {
    .exhibitionDetails{
        padding-top: 150px;
    }
}
// .btn {
//     width: 134px;
//     height: 40px;
//     border: 1px solid #191919;
//     color: #656665;
//     font-size: 14px;
//     color: #656665;
//     line-height: 40px;
//     text-align: center;
//     cursor: pointer;
//     border-radius: 20px;
// }

// .btn:hover {
//     background: #1663FF;
//     color: #FFFFFF;
//     border: none;
// }
</style>
